import { queryOptions } from '@tanstack/react-query'
import { apiGet } from './client'

/**
 * "Location Monitoring" - `Easeedesk::gps_tracking`, harta cu oamenii de teren
 * si sediile clientilor.
 *
 * Capetele vechi stateau in `Location_monitoring` si erau POST-uri fara nicio
 * poarta (si scoase din verificarea CSRF). Aici sunt citiri (GET), fiecare cu
 * dreptul si treapta de acces ale ecranului. Vezi `App\Easeedesk\Gps\GpsTracking`.
 */

export interface GpsAccountManager {
  id: number
  name: string
  /** Numele fisierului de pastila din `public/images/location_monitoring/`. */
  color: string
  companies: number
}

export interface GpsPage {
  ready: boolean
  /** Cheia de browser a Google Maps, din mediu. Goala = harta nu se poate desena. */
  mapsKey: string
  center: { lat: number; lng: number }
  accountManagers: GpsAccountManager[]
}

export interface GpsSysadmin {
  id: number
  lat: number
  lng: number
  activity: number
  picture: string
  name: string
  checkIn: string
  eta: string
}

export interface GpsOffice {
  id: number
  company: string
  office: string
  lat: number
  lng: number
  color: string
  tickets: number
  accountManager: string
  admin: string
}

export interface GpsSysadminInfo {
  name: string
  activity: 'commuting' | 'checkedIn' | 'checkedOut'
  company: string
  office: string
  fixedLocation: boolean
  car: string
  lastSeen: string
  lat: number
  lng: number
}

export interface GpsRoutePoint {
  latitude: number
  longitude: number
  speed: number
  date: string
}

export const gpsPageQuery = queryOptions({
  queryKey: ['easeedesk', 'gps', 'page'],
  queryFn: () => apiGet<GpsPage>('/easeedesk/gps-tracking'),
})

export function gpsSysadminsQuery(filter: string) {
  return queryOptions({
    queryKey: ['easeedesk', 'gps', 'sysadmins', filter] as const,
    queryFn: () =>
      apiGet<{ sysadmins: GpsSysadmin[] }>(
        filter === '' ? '/easeedesk/gps-tracking/sysadmins' : `/easeedesk/gps-tracking/sysadmins?filter=${encodeURIComponent(filter)}`,
      ),
    /* Ecranul vechi se reimprospata singur la cinci minute. */
    refetchInterval: 300_000,
  })
}

export const gpsOfficesQuery = queryOptions({
  queryKey: ['easeedesk', 'gps', 'offices'],
  queryFn: () => apiGet<{ offices: GpsOffice[] }>('/easeedesk/gps-tracking/offices'),
  refetchInterval: 300_000,
})

export function fetchGpsSysadmin(id: number, activity: number): Promise<GpsSysadminInfo> {
  return apiGet<GpsSysadminInfo>(`/easeedesk/gps-tracking/sysadmins/${id}?activity=${activity}`)
}

export function fetchGpsRoute(user: number, from: string, to: string): Promise<{ history: GpsRoutePoint[] }> {
  const p = new URLSearchParams({ user: String(user), from, to })
  return apiGet<{ history: GpsRoutePoint[] }>(`/easeedesk/gps-tracking/route?${p.toString()}`)
}
